export const timeline = [
  {
    phase: "01",
    title: "Observasi",
    date: "1 — 7 Juli 2026",
    description:
      "Pemetaan kondisi sosial, pendidikan, dan lingkungan Kelurahan Kedungwuni Barat bersama perangkat kelurahan.",
    icon: "Search",
  },
  {
    phase: "02",
    title: "Koordinasi",
    date: "8 — 14 Juli 2026",
    description:
      "Audiensi dengan lurah, takmir masjid, sekolah mitra, karang taruna, dan tokoh masyarakat.",
    icon: "Users",
  },
  {
    phase: "03",
    title: "Perencanaan",
    date: "15 — 21 Juli 2026",
    description:
      "Penyusunan program kerja terpadu berbasis hasil observasi dan kebutuhan warga.",
    icon: "ClipboardList",
  },
  {
    phase: "04",
    title: "Pelaksanaan",
    date: "22 Juli — 25 Agustus 2026",
    description:
      "Eksekusi seluruh program kerja: Eco Masjid, Sedekah Sampah, pendidikan, dan digitalisasi.",
    icon: "Rocket",
  },
  {
    phase: "05",
    title: "Evaluasi",
    date: "26 — 31 Agustus 2026",
    description:
      "Monitoring capaian, evaluasi bersama mitra, dan penyusunan laporan akhir.",
    icon: "TrendingUp",
  },
  {
    phase: "06",
    title: "Penutupan",
    date: "1 — 5 September 2026",
    description:
      "Serah terima program berkelanjutan, pentas seni santri, dan penarikan resmi KKN.",
    icon: "Flag",
  },
];
